export function setLocalStorage(name, val) {
  return localStorage.setItem(name, val);
}

export function getLocalStorage(name) {
  const val = localStorage.getItem(name);
  return val;
}

export function deleteLocalStorage(name) {
  return localStorage.removeItem(name);
}
export function hasPermission(name) {
  const user = localStorage.getItem("user");
  if (!user) return false;
  const data = JSON.parse(user);
  const check = data.roles[0]?.permissions.find((item) => item.name === name);
  if (check) return true;
  return false;
}
